import { object, string } from "yup";

export const couponSchema = object({
  couponCode: string().min(1),
});
